import getLocalString from "constants/Localization";
import { useCustomAddPlantProductToProposalProductMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useAddPlantProductToProposalProduct() {
  const [mutation, { loading, error, data }] = useCustomAddPlantProductToProposalProductMutation({
    refetchQueries: ["customGetProposal"],
  });

  const [addPlantProductToProposalProduct, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "addPlantProductToProposalProduct",
    },
    {
      successMessage: getLocalString("proposals.add-plant-product-to-proposal-product-success"),
      failureMessage: getLocalString("proposals.add-plant-product-to-proposal-product-failure"),
    }
  );

  return [addPlantProductToProposalProduct, context] as const;
}
